import { ConversationMessage } from "@/gql/graphql";
import { ref } from "vue";
const incomingMessage = ref();

const setIncomingMessage = (message: ConversationMessage | null) => incomingMessage.value = message;

export {setIncomingMessage, incomingMessage}